import type { ReactElement, ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface Props {
  children: ReactNode;
  fallback?: ReactElement;
}

const ErrorBoundary = ({ children, fallback }: Props) => (
  <ReactErrorBoundary
    fallback={fallback || <h1>An error has occurred</h1>}
    children={children}
  />
);

export default ErrorBoundary;
